import colors from "@src/common/styles/colors";
import {
  DEFAULT_MARGIN_L,
  DEFAULT_MARGIN_M,
  DEFAULT_MARGIN_S,
} from "@src/common/styles/const";
import { media } from "@src/common/styles/mixins";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  padding: ${DEFAULT_MARGIN_L}px;
  text-align: center;
  background-color: ${colors.background};
`;

export const Title = styled.h1`
  color: ${colors.almostBlack};
  margin-bottom: ${DEFAULT_MARGIN_M}px;
`;

export const Message = styled.p`
  color: ${colors.gray3};
  max-width: 500px;
  margin-bottom: ${DEFAULT_MARGIN_L}px;
  line-height: 1.5;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: ${DEFAULT_MARGIN_S}px;
  flex-direction: column;

  ${media.up("TABLET")`
        flex-direction: row;
    `}
`;
